<template>
  <div>
    <div v-if="mode === 'DESIGN'">
      <!--组件在设计器中的样子-->
      <el-select class="max-fill" size="medium" v-model="_value" disabled :placeholder="placeholder" />
    </div>
    <div v-else-if="mode === 'PC' && !readonly">
      <!--组件在PC端预览及真实显示的样子-->
      <el-select class="max-fill" size="medium" v-model="_value" :placeholder="placeholder" multiple filterable value-key="id">
        <el-option v-for="item in option" :key="item.id" :label="item.name" :value="item"> </el-option>
      </el-select>
    </div>
    <div v-else-if="mode === 'MOBILE' && !readonly">
      <!--组件在移动端预览及真实显示的样子-->
      <el-select class="max-fill" size="medium" v-model="_value" :placeholder="placeholder" multiple filterable value-key="id">
        <el-option v-for="item in option" :key="item.id" :label="item.name" :value="item"></el-option>
      </el-select>
    </div>
    <div v-else>
      <!--组件在流程实例预览中，只读状态下样子-->
      <span v-for="item in _value">{{ item.name }}</br></span>
    </div>
  </div>
</template>

<script>
//混入配置
import componentMinxins from '../ComponentMinxins'
export default {
  mixins: [componentMinxins],
  name: "ConServiceItemInput",
  components: {},
  props: {
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    option: {
      type: Array,
      default: () => []
    },
    parent: {
      type: String,
      default: () => {
        return ''
      }
    },
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    propValue: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  watch: {
    formData: {
      handler(newFormData, oldFormData) {
        if (this.parent && newFormData) {
          const currentParentValue = newFormData[this.parent];
          const previousParentValue = this.previousParentValue;
          
          // 更新缓存值
          this.previousParentValue = currentParentValue;
          
          // 比较父级字段的值是否发生变化
          if (previousParentValue !== currentParentValue) {
            // 只在编辑模式且不是设计模式下清空选择
            const isEditMode = this.mode !== 'DESIGN' && 
                              this.mode !== 'READONLY' && 
                              !this.readonly;
            
            if (isEditMode) {
              this.$emit('input', []);
              this.$forceUpdate();
            }
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    _value: {
      get() {
        return this.value || [];
      },
      set(val) {
        this.$emit('input', val || []);
      }
    }
  },
  data() {
    return {
      placeholder: '请选择数据',
      optionChangeTimer: null,
      previousParentValue: undefined // 缓存父级字段的旧值
    }
  },
  methods: {

  }
}
</script>
<style>
.popper-select {
  li[aria-haspopup="true"] {
    .el-checkbox {
      display: none;
    }
  }
}
</style>
